/* Icespheric bag drawer, built on Shopify's Cart API. Prices, savings and totals come from the cart itself. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ice-bag]');
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-bag-config]').textContent); } catch (e) {}
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var html = document.documentElement;
  var panel = root.querySelector('[data-bag-panel]');
  var view = root.querySelector('[data-bag-view]');
  var countEl = root.querySelector('[data-bag-n]');
  var payTpl = root.querySelector('[data-bag-pay]');
  var pay = payTpl ? payTpl.innerHTML : '';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var opener = null;
  var cart = null;
  var note = '';
  var busy = false;
  var isOpen = false;
  var lastScale = 0;
  var wasFree = false;
  var fromStart = false;

  var ICON_MINUS = `<svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.8' stroke-linecap='round' aria-hidden='true'><path d='M5 12h14'></path></svg>`;
  var ICON_TRUCK = `<svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M3 7h11v9H3z'></path><path d='M14 10h4l3 3v3h-7'></path><circle cx='7' cy='17.5' r='1.6'></circle><circle cx='17' cy='17.5' r='1.6'></circle></svg>`;
  var ICON_PLUS = `<svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.8' stroke-linecap='round' aria-hidden='true'><path d='M12 5v14'></path><path d='M5 12h14'></path></svg>`;

  function money(c) { return '£' + (c / 100).toFixed(2); }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML.split(String.fromCharCode(39)).join('&#39;');
  }
  function isGlove(it) { return (cfg.gloves || []).indexOf(it.product_id) !== -1; }
  // Stacking mode: the battery deal comes from a discount app (Selleasy) that only discounts battery lines
  // tagged with a glove in the cart, so it adds to the bundle saving. The bag keeps one tagged battery per pair of gloves.
  var stack = !!(cfg.battery && cfg.battery.stack);
  function battTag(productId) { return String(productId) + (cfg.battery.tagSuffix || ''); }
  function tagOf(it) { return it.properties && cfg.battery && cfg.battery.tagKey ? it.properties[cfg.battery.tagKey] : null; }
  function label(t) { return cfg.battery && cfg.battery.code && t === cfg.battery.code ? (cfg.battery.label || t) : t; }
  function isBattery(it) { return !!cfg.battery && it.product_id === cfg.battery.productId; }
  function shortName(it) {
    if (isBattery(it)) return cfg.battery.name || it.product_title;
    var t = String(it.product_title).replace('Icespheric™ ', '').replace('Icespheric ', '').replace('IcePro ', '');
    return t.replace(' Heated Mitten', ' Mitten Heated').split(' Heated')[0].trim() || t;
  }
  function variantLine(it) {
    if (isBattery(it)) return cfg.battery.variant || '';
    var opts = it.options_with_values || [];
    var size = opts.filter(function (o) { return /size/i.test(o.name); })[0];
    if (size) return 'Size ' + String(size.value).split(' (')[0];
    return it.variant_title || '';
  }
  function thumb(it) {
    var u = it.image || '';
    if (!u) return '';
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=200';
  }

  function req(path, body) {
    return fetch(base + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
        return j;
      });
    });
  }

  function setCart(c) {
    cart = c;
    paint();
    count();
    document.dispatchEvent(new CustomEvent('ice:cart', { detail: c }));
    return c;
  }
  function load() { return req('cart.js').then(balance).then(setCart); }

  // One tagged (discounted) battery pair per pair of gloves; any extra pairs untagged at full price.
  // Tags always name a glove that is in the bag, and the discount code is on the cart only while it's needed.
  function balance(c) {
    if (!stack || !c || !cfg.battery || !cfg.battery.tagKey) return c;
    var items = c.items || [];
    var gloves = items.filter(isGlove);
    var gloveIds = gloves.map(function (g) { return battTag(g.product_id); });
    var gloveQty = gloves.reduce(function (n, g) { return n + g.quantity; }, 0);
    var batts = items.filter(isBattery);
    var total = batts.reduce(function (n, b) { return n + b.quantity; }, 0);
    var want = Math.min(total, gloveQty);
    var good = 0, bad = 0;
    batts.forEach(function (b) { var t = tagOf(b); if (t && gloveIds.indexOf(t) !== -1) good += b.quantity; else if (t) bad += b.quantity; });
    var codes = (c.discount_codes || []).map(function (d) { return d.code; });
    var code = cfg.battery.code;
    var hasCode = !!code && codes.indexOf(code) !== -1;
    var needCode = !!code && want > 0;
    var linesOk = good === want && bad === 0;
    if (linesOk && hasCode === needCode) return c;

    var body = {};
    if (hasCode !== needCode) {
      var next = codes.filter(function (x) { return x !== code; });
      if (needCode) next.push(code);
      body.discount = next.join(',');
    }
    var readd = [];
    if (!linesOk) {
      body.updates = {};
      batts.forEach(function (b) { body.updates[b.key] = 0; });
      var variant = batts[0].variant_id;
      if (want > 0) { var tagged = { id: variant, quantity: want, properties: {} }; tagged.properties[cfg.battery.tagKey] = gloveIds[0]; readd.push(tagged); }
      if (total - want > 0) readd.push({ id: variant, quantity: total - want });
    }
    return req('cart/update.js', body)
      .then(function () { return readd.length ? req('cart/add.js', { items: readd }) : null; })
      .then(function () { return req('cart.js'); })
      .then(function (fresh) { balanced = true; return fresh; }, function () { return c; });
  }
  var balanced = false;

  function count() {
    var n = cart ? cart.item_count : 0;
    document.querySelectorAll('[data-bag-count]').forEach(function (b) { b.textContent = String(n); b.hidden = n === 0; });
    document.querySelectorAll('[data-bag-open]').forEach(function (a) { a.setAttribute('aria-label', 'Bag, ' + n + (n === 1 ? ' item' : ' items')); });
    if (countEl) countEl.textContent = n ? '(' + n + ')' : '';
  }

  function paint() {
    if (!view) return;
    var alert = note ? `<p class='ice-bag__alert' role='alert'>${esc(note)}</p>` : '';
    if (!cart) {
      view.innerHTML = `<div class='ice-bag__body'>${alert || `<p class='ice-bag__muted'>Loading your bag…</p>`}</div>`;
      return;
    }
    var items = cart.items || [];
    if (!items.length) {
      view.innerHTML = `<div class='ice-bag__empty'>${alert}<h3>Your bag is empty.</h3><p>Free tracked UK delivery on every glove order, and a 30-day Warmth Guarantee.</p><div class='ice-bag__empty-actions'><a class='ice-bag__btn ice-bag__btn--primary' href='${esc(cfg.shopUrl || '/')}' data-bag-close>Shop gloves</a><a class='ice-bag__btn ice-bag__btn--ghost' href='${esc(cfg.findUrl || '/')}' data-bag-close>Find your glove</a></div></div>`;
      return;
    }

    var gloveQty = 0;
    var battQty = 0;
    var battDeal = 0;
    var gloveSaved = 0;
    var saves = {};
    var order = [];
    var rank = function (it) { return isGlove(it) ? 0 : isBattery(it) ? 2 : 1; };
    var saved = function (it) { return (it.line_level_discount_allocations || []).reduce(function (n, a) { return n + (a.amount || 0); }, 0); };
    items = items.slice().sort(function (a, b) { return rank(a) - rank(b); });
    items.forEach(function (it) {
      if (isGlove(it)) { gloveQty += it.quantity; gloveSaved += saved(it); }
      if (isBattery(it)) { battQty += it.quantity; if (saved(it) > 0) battDeal += it.quantity; }
    });
    var lines = items.map(function (it) {
      var chips = [];
      (it.line_level_discount_allocations || []).forEach(function (a) {
        if (!a.amount) return;
        var t = label((a.discount_application && a.discount_application.title) || 'Saving');
        if (!(t in saves)) { saves[t] = 0; order.push(t); }
        saves[t] += a.amount;
        if (chips.indexOf(t) === -1) chips.push(t);
      });
      // Explain a full-price battery pair when gloves are in the bag.
      var why = '';
      if (isBattery(it) && gloveQty > 0 && saved(it) === 0) {
        if (battDeal >= gloveQty) why = 'Extra pair at full price. The half-price deal covers one battery pair for each pair of gloves.';
        else if (gloveSaved > 0 && !stack) why = 'Full price because your bundle saving is bigger. Savings don’t add together, so you get whichever saves you more.';
      }
      var orig = it.original_line_price;
      var fin = it.final_line_price;
      var name = shortName(it);
      var img = thumb(it);
      return `<li class='ice-bag__line'>
        <a class='ice-bag__thumb' href='${esc(it.url)}' tabindex='-1' aria-hidden='true'>${img ? `<img src='${esc(img)}' alt='' loading='lazy' width='84' height='84'>` : ''}</a>
        <div class='ice-bag__info'>
          <div class='ice-bag__row'><a class='ice-bag__name' href='${esc(it.url)}'>${esc(name)}</a><span class='ice-bag__price'><span>${money(fin)}</span>${orig > fin ? `<s><span class='ice-sr'>was </span>${money(orig)}</s>` : ''}</span></div>
          <span class='ice-bag__variant'>${esc(variantLine(it))}</span>
          ${chips.map(function (c) { return `<span class='ice-bag__chip'>${esc(c)}</span>`; }).join('')}
          ${why ? `<span class='ice-bag__why'>${esc(why)}</span>` : ''}
          <div class='ice-bag__row ice-bag__controls'>
            <span class='ice-bag__step' role='group' aria-label='Quantity of ${esc(name)}'>
              <button type='button' aria-label='One fewer' data-qty='${esc(it.key)}' data-to='${it.quantity - 1}'${it.quantity <= 1 ? ' disabled' : ''}>${ICON_MINUS}</button>
              <output>${it.quantity}</output>
              <button type='button' aria-label='One more' data-qty='${esc(it.key)}' data-to='${it.quantity + 1}'>${ICON_PLUS}</button>
            </span>
            <button class='ice-bag__remove' type='button' data-qty='${esc(it.key)}' data-to='0'>Remove</button>
          </div>
        </div>
      </li>`;
    }).join('');
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      var t = label(a.title || 'Discount');
      if (!(t in saves)) { saves[t] = 0; order.push(t); }
      saves[t] += a.total_allocated_amount || 0;
    });

    var total = cart.total_price;
    var free = cfg.freeExpress || 0;
    var express = '';
    var scale = 0;
    var on = false;
    if (gloveQty > 0 && free > 0) {
      on = total >= free;
      scale = Math.min(1, total / free);
      var from = fromStart ? 0 : Math.min(lastScale, 1);
      express = `<div class='ice-bag__express${on ? ' is-on' : ''}${on && !wasFree ? ' is-arrived' : ''}'><span>${on ? `You have <strong>free express delivery</strong>, 1 to 2 working days.` : `You are <strong>${money(free - total)} away</strong> from free express delivery.`}</span><div class='ice-bag__road' aria-hidden='true'><div class='ice-bag__bar'><span data-bar style='transform: scaleX(${from.toFixed(3)})'></span></div><span class='ice-bag__truck' data-truck style='left: ${(from * 100).toFixed(1)}%'>${ICON_TRUCK}</span></div></div>`;
    }
    var onlyBatt = gloveQty === 0 && battQty > 0 ? `<p class='ice-bag__muted'>Spare batteries on their own ship free by specialist courier, UK mainland only, in 3 to 5 working days.</p>` : '';

    var offer = '';
    var b = cfg.battery;
    if (b && b.available && gloveQty > battQty) {
      // Shopify gives whichever saving is bigger: the bundle on the gloves or the battery deal. Predict which wins once this pair is added.
      var dealAfter = Math.min(battQty + 1, gloveQty) * (b.price - b.half);
      var bundleNow = bundleEstimate(items, gloveQty);
      var dealWins = stack || dealAfter > bundleNow;
      var line = dealWins
        ? `Half price with your gloves: ${money(b.half)} <s><span class='ice-sr'>was </span>${money(b.price)}</s>`
        : `${money(b.price)}. Your bundle saving of ${money(bundleNow)} is bigger than the battery deal, so you keep that.`;
      offer = `<div class='ice-bag__offer'>
        <span class='ice-bag__thumb ice-bag__thumb--sm' aria-hidden='true'>${b.img ? `<img src='${esc(b.img)}' alt='' loading='lazy'>` : ''}</span>
        <span class='ice-bag__offer-text'><strong>Add a spare battery pair</strong><span>${line}</span></span>
        <button class='ice-bag__small-btn' type='button' data-bag-add-batt>Add</button>
      </div>`;
    }
    var p = cfg.packs || [0, 15, 20];
    var nudge = '';
    if (gloveQty === 1 && p[1]) nudge = `Add any second pair and <strong>save ${p[1]}% on both.</strong>`;
    else if (gloveQty === 2 && p[2]) nudge = `Add a third pair and <strong>save ${p[2]}% on all three.</strong>`;
    else if (gloveQty === 0 && battQty > 0 && b) nudge = `Add any gloves and your spare batteries are <strong>half price.</strong>`;
    if (nudge) nudge = `<div class='ice-bag__nudge'><span>${nudge}</span><a class='ice-bag__link' href='${esc(cfg.shopUrl || '/')}' data-bag-close>Shop gloves</a></div>`;

    var saveRows = order.map(function (t) {
      return `<div class='ice-bag__sum is-save'><span>${esc(t)}</span><span>−${money(saves[t])}</span></div>`;
    }).join('');
    if (!stack && gloveQty >= 2 && battQty > 0) saveRows += `<p class='ice-bag__why'>Bundle and battery savings don’t add together. Your bag uses whichever saves you more.</p>`;

    view.innerHTML = `<div class='ice-bag__body'>
        ${alert}${express}${onlyBatt}
        <ul class='ice-bag__lines' aria-label='Items in your bag'>${lines}</ul>
        ${offer}${nudge}
      </div>
      <div class='ice-bag__foot'>
        ${saveRows}
        <div class='ice-bag__total'><span>Subtotal</span><span>${money(total)}</span></div>
        ${cfg.fine ? `<p class='ice-bag__fine'>${esc(cfg.fine)}</p>` : ''}
        <form action='${base}cart' method='post' class='ice-bag__checkout'><button class='ice-bag__btn ice-bag__btn--primary' type='submit' name='checkout'>Checkout</button></form>
        ${pay}
      </div>`;

    // Drive the truck from where it was to where it is now.
    var bar = view.querySelector('[data-bar]');
    var truck = view.querySelector('[data-truck]');
    if (bar && truck) {
      fromStart = false;
      var moved = Math.abs(scale - from) > 0.002;
      // When it stops, the truck pitches forward on its front wheels like an emergency stop.
      truck.addEventListener('transitionend', function (e) {
        if (e.propertyName !== 'left') return;
        truck.classList.remove('is-driving');
        truck.classList.add('is-braking');
      }, { once: true });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (moved && !reduce) truck.classList.add('is-driving');
          bar.style.transform = 'scaleX(' + scale.toFixed(3) + ')';
          truck.style.left = (scale * 100).toFixed(1) + '%';
        });
      });
    }
    lastScale = scale;
    wasFree = on;
  }

  // The bundle saving Shopify would give on the gloves in the bag: a percentage off each pair, rounded down to the penny.
  function bundleEstimate(items, gloveQty) {
    var p = cfg.packs || [0, 15, 20];
    var pct = gloveQty >= 3 ? p[2] : gloveQty === 2 ? p[1] : 0;
    if (!pct) return 0;
    return items.reduce(function (n, it) {
      if (!isGlove(it)) return n;
      var unit = it.original_price || it.price;
      return n + Math.floor(unit * pct / 100) * it.quantity;
    }, 0);
  }

  function change(key, qty) {
    if (busy) return;
    busy = true;
    note = '';
    root.setAttribute('aria-busy', 'true');
    req('cart/change.js', { id: key, quantity: qty })
      .then(balance)
      .then(setCart, function (e) { note = e.message; paint(); })
      .then(function () { busy = false; root.removeAttribute('aria-busy'); });
  }

  function add(items) {
    note = '';
    return req('cart/add.js', { items: items }).then(function () { return load(); }).then(function (c) { open(); return c; });
  }

  function trap(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex=-1])');
    f = Array.prototype.filter.call(f, function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open() {
    if (isOpen) { paint(); return; }
    isOpen = true;
    fromStart = true;
    opener = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    html.classList.add('ice-locked');
    document.querySelectorAll('[data-bag-open]').forEach(function (a) { a.setAttribute('aria-expanded', 'true'); });
    if (!cart) paint();
    if (panel) panel.focus({ preventScroll: true });
    load().catch(function () {
      if (!cart) { note = 'We could not load your bag just now. Please refresh the page and try again.'; paint(); }
    });
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    html.classList.remove('ice-locked');
    document.querySelectorAll('[data-bag-open]').forEach(function (a) { a.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { if (!isOpen) root.hidden = true; }, reduce ? 0 : 450);
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }

  root.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    var q = t.closest('[data-qty]');
    if (q) { change(q.getAttribute('data-qty'), Number(q.getAttribute('data-to'))); return; }
    if (t.closest('[data-bag-add-batt]') && cfg.battery) {
      t.closest('[data-bag-add-batt]').disabled = true;
      var g = (cart && cart.items || []).filter(isGlove)[0];
      var item = { id: cfg.battery.variantId, quantity: 1 };
      if (stack && g && cfg.battery.tagKey) { item.properties = {}; item.properties[cfg.battery.tagKey] = battTag(g.product_id); }
      add([item]).catch(function (err) { note = err.message; paint(); });
      return;
    }
    if (t.closest('[data-bag-close]')) close();
  });
  root.addEventListener('keydown', trap);
  document.addEventListener('keydown', function (e) { if (isOpen && e.key === 'Escape') close(); });

  document.addEventListener('click', function (e) {
    var a = e.target instanceof Element && e.target.closest('[data-bag-open]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    open();
  });

  /* Simple add-to-bag forms (for example the spare batteries section) add in place and open the bag. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || !f.closest('.ice') || f.closest('[data-ice-bag]')) return;
    if ((f.getAttribute('action') || '').indexOf('/cart/add') === -1 || f.classList.contains('ice-pdp__terms-form')) return;
    var idEl = f.querySelector('[name=id]');
    if (!idEl) return;
    e.preventDefault();
    var qEl = f.querySelector('[name=quantity]');
    var btn = f.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    add([{ id: Number(idEl.value), quantity: Number(qEl ? qEl.value : 1) || 1 }])
      .catch(function (err) { note = err.message; open(); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) load().catch(function () {}); });
  if (stack && document.querySelector('[data-cart-page]')) {
    load().then(function () { if (balanced) window.location.reload(); }).catch(function () {});
  }

  window.IceBag = { open: open, close: close, add: add, refresh: load, stack: stack };
})();
